/* Make entire row (text + arrow) open submenus on mobile
   - First tap on a parent with a real URL => open submenu (no nav)
   - Second tap on the text => follow the link
*/
(function () {
  const MENU_SCOPE = '.canvas-menu';         // your off-canvas wrapper
  const MOBILE_BP = 1024;                     // keep desktop hover intact

  function isMobile() {
    return window.innerWidth < MOBILE_BP;
  }

  // real link = navigates to a page (not "#" and not "#mm-...")
  function hasRealHref(a) {
    if (!a) return false;
    const href = a.getAttribute('href') || '';
    if (!href) return false;
    if (href === '#') return false;
    if (href.startsWith('#mm-')) return false;
    return true;
  }

  // Find the sibling mm-next that mmenu uses to open a panel
  function siblingNext(li) {
    return li ? li.querySelector(':scope > a.mm-next') : null;
  }

  function handleTextTap(e) {
    if (!isMobile()) return;
    const a = e.target.closest(
      `${MENU_SCOPE} a.site-nav__link--main, ${MENU_SCOPE} a.site-nav__link--second`
    );
    if (!a) return;

    const li = a.closest('li');
    const next = siblingNext(li);

    // If this row has a submenu:
    if (next) {
      const real = hasRealHref(a);

      // If the parent also links to a page, use "first tap opens / second tap navigates"
      if (real) {
        if (!li.dataset.tappedOnce) {
          e.preventDefault();
          li.dataset.tappedOnce = '1';
          next.click(); // opens the submenu
          return;
        }
        // second tap on the text will navigate normally
        return;
      }

      // If the parent text link is "#" (group header), always toggle and block nav
      e.preventDefault();
      next.click();
    }
    // If no submenu: behave like a normal link
  }

  function clearTapStateOnBack(e) {
    if (!isMobile()) return;
    const back = e.target.closest(`${MENU_SCOPE} .mm-btn.mm-prev`);
    if (!back) return;

    // When going back, clear the "tapped once" flag so first tap opens again
    const panel = back.closest('.mm-panel');
    if (!panel) return;

    // Clear flags for all listitems in the previous panel
    const prevPanelId = back.getAttribute('href'); // e.g. "#mm-1"
    const prevPanel = prevPanelId ? document.querySelector(prevPanelId) : null;
    if (!prevPanel) return;

    prevPanel.querySelectorAll('li[data-tapped-once], li[data-tappedonce], li[data-tapped-once="1"]').forEach(li => {
      delete li.dataset.tappedOnce;
    });
    prevPanel.querySelectorAll('li').forEach(li => { delete li.dataset.tappedOnce; });
  }

  function init() {
    const scope = document.querySelector(MENU_SCOPE);
    if (!scope) return;

    // Delegate: tap on text opens submenu like the arrow
    scope.addEventListener('click', handleTextTap, true);

    // Delegate: when hitting the mm-prev (back), clear “first tap” memory
    scope.addEventListener('click', clearTapStateOnBack, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
